import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column align-items-center py-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", { class: "mb-2 font-size-base" }, " Do you want to create a palliative care provider order? ", -1 /* HOISTED */)
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = {
  key: 0,
  id: "Attach__PhysicianOrder"
}
const _hoisted_5 = { class: "mb-2 w-100 d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "font-size-sm"
}
const _hoisted_7 = { class: "w-100 row g-0" }
const _hoisted_8 = { class: "col-12 col-md-4 col-sm-6 card-wrapper" }
const _hoisted_9 = { class: "d-flex flex-column align-items-center py-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", { class: "mb-2 font-size-base" }, " There are no open Palliative Care Orders assigned to you. ", -1 /* HOISTED */)
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "mb-0 text-dark" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-app-secondary" }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Updates will be added to ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Order scheduled on ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_17 = { class: "d-flex ms-auto" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle text-danger" }),
  /*#__PURE__*/_createTextVNode(" There was a problem while adding loading the Palliative Care Provider Order selected. Please choose again. ")
], -1 /* HOISTED */)
const _hoisted_19 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_20 = { class: "w-100 row mb-2" }
const _hoisted_21 = { class: "form-group col-12 col-md-5 offset-md-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mb-1" }, " Date ", -1 /* HOISTED */)
const _hoisted_23 = { class: "input-group date datepickerInput" }
const _hoisted_24 = ["value"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_26 = { class: "form-group col-12 col-md-5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mb-1" }, " Palliative Care Provider ", -1 /* HOISTED */)
const _hoisted_28 = {
  key: 2,
  class: "text-center"
}
const _hoisted_29 = {
  key: 3,
  class: "p-3 d-flex flex-column text-center text-primary"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("b", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Creating Palliative Care Provider Order...")
], -1 /* HOISTED */)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhysicianOrderCard = _resolveComponent("PhysicianOrderCard")!
  const _component_FormatName = _resolveComponent("FormatName")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (!_ctx.isProviderOrderRequested && !_ctx.isUrlOrderSelected)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-xs btn-success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestProviderOrder()))
          }, "Yes"),
          _createElementVNode("button", {
            class: "btn btn-xs btn-danger ms-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeRequestProviderOrder()))
          }, "No")
        ])
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createCommentVNode(" SELECT ORDER FROM OPEN ORDERS SECTION "),
        (!_ctx.isNewOrderRequested && !_ctx.isNewOrderInProgress && _ctx.isChooseOrderRequested)
          ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
              (_ctx.openOrders.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("section", _hoisted_5, [
                      (_ctx.entity)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_6, " Select an order to update the patient's " + _toDisplayString(_ctx.entity) + ". ", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        class: "btn btn-primary btn-xs ms-auto",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openNewOrder()))
                      }, " Create Provider Order ")
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openOrders, (order) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_PhysicianOrderCard, {
                            order: order,
                            "selected-order": _ctx.currentOrder,
                            "get-physicians": _ctx.getPhysicians,
                            "select-order": _ctx.selectOrder,
                            "open-order": _ctx.openOrder
                          }, null, 8 /* PROPS */, ["order", "selected-order", "get-physicians", "select-order", "open-order"])
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary btn-xs py-0 my-1 px-2",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeOrderSelection()))
                    }, " Cancel ")
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" NO OPEN ORDERS "),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("section", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "btn btn-xs btn-primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openNewOrder()))
                        }, "Create Provider Order"),
                        _createElementVNode("button", {
                          class: "btn btn-xs btn-outline-secondary ms-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeOrderSelection()))
                        }, "Cancel")
                      ])
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ORDER SELECTED UI "),
        (!_ctx.isChooseOrderRequested && _ctx.orderId && _ctx.currentOrder)
          ? (_openBlock(), _createElementBlock("section", {
              key: 1,
              id: "Attach__OrderSelected",
              class: _normalizeClass(`animated alert alert-app-secondary ${
                !_ctx.isChooseOrderRequested && _ctx.orderId ? 'faster fadeInDown' : 'slow fadeOutUp'
            }`)
            }, [
              _createElementVNode("p", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("b", null, [
                  _createVNode(_component_FormatName, {
                    "first-name": _ctx.currentOrder.PhysicianFirstName,
                    "last-name": _ctx.currentOrder.PhysicianLastName,
                    format: "FN LN"
                  }, null, 8 /* PROPS */, ["first-name", "last-name"])
                ]),
                _hoisted_15,
                _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(_ctx.currentOrder.OrderDate)), 1 /* TEXT */),
                _hoisted_16
              ]),
              _createElementVNode("section", _hoisted_17, [
                (!_ctx.isUrlOrderSelected)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-xs py-0 btn-primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openOrder(_ctx.currentOrder)))
                    }, " View Order "))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-xs py-0 btn-primary ms-1",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeOrder()))
                }, " Change Order "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-xs py-0 btn-success ms-1",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleExit()))
                }, _toDisplayString(_ctx.urlNoteId ? "Return to Order" : "Done"), 1 /* TEXT */)
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ERROR "),
        (!_ctx.isChooseOrderRequested && _ctx.orderId && !_ctx.currentOrder)
          ? (_openBlock(), _createElementBlock("section", {
              key: 2,
              id: "Attach__Error",
              class: _normalizeClass(`animated alert alert-danger ${
                !_ctx.isChooseOrderRequested && _ctx.orderId ? 'faster fadeInDown' : 'slow fadeOutUp'
            }`)
            }, [
              _hoisted_18,
              _createElementVNode("button", {
                type: "button",
                class: "btn table-btn btn-outline-primary ms-auto",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeOrder()))
              }, " Choose ")
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" CREATE ORDER FORM "),
        (_ctx.isNewOrderRequested)
          ? (_openBlock(), _createElementBlock("section", {
              key: 3,
              id: "Attach__OrderForm",
              class: _normalizeClass(`animated ${_ctx.isNewOrderRequested ? 'faster fadeInDown' : 'slow fadeOutUp'}`)
            }, [
              (!_ctx.isNewOrderInProgress)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_19, "New Palliative Care Provider Order"))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNewOrderInProgress)
                ? (_openBlock(), _createBlock(_component_FormSection, { key: 1 }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("input", {
                                  name: "order-date",
                                  type: "text",
                                  class: _normalizeClass(["form-control", `${!_ctx.v$.orderDate.$error ? '' : 'field-invalid'}`]),
                                  placeholder: "MM/DD/YYYY",
                                  value: _ctx.formatDateInput(_ctx.orderDate),
                                  autocomplete: "off",
                                  "date-format-only": "",
                                  onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.orderDate.$touch && _ctx.v$.orderDate.$touch(...args)))
                                }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_24),
                                _hoisted_25
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["getDate"])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createVNode(_component_TypeaheadInput, {
                            getData: _ctx.getPhysicians,
                            value: _ctx.orderSelectedPhysician,
                            placeholder: "Type to Search Provider...",
                            "character-limit": 3,
                            onValueChanged: _ctx.orderSelectedPhysicianChanged,
                            onBlurredInput: _ctx.v$.orderSelectedPhysician.$touch,
                            class: _normalizeClass(`${!_ctx.v$.orderSelectedPhysician.$error ? '' : 'field-invalid'}`)
                          }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "class"])
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNewOrderInProgress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-xs",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.createPhysicianOrder()))
                    }, "Create"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary btn-xs ms-2",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeNewOrder()))
                    }, " Cancel ")
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" LOADING "),
              (_ctx.isNewOrderInProgress)
                ? (_openBlock(), _createElementBlock("section", _hoisted_29, _hoisted_32))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
}